import React, { useState, useEffect } from 'react';
import { EVENTS } from '../utilities/CONSTANTS';

const useGoogleDriveSearch = () => {
    const [googleDriveSearch, setGoogleDriveSearch] = useState(() => window.googleDriveSearch);

    useEffect(() => {
        const handleGoogleDriveTokenLoaded = () => {
            if (window.googleDriveSearch) {
                setGoogleDriveSearch(() => window.googleDriveSearch);
            } else {
                setGoogleDriveSearch(false);
            }
        };
        window.addEventListener(EVENTS.GOOGLE_TOKEN_LOADED, handleGoogleDriveTokenLoaded);
        return () => window.removeEventListener(EVENTS.GOOGLE_TOKEN_LOADED, handleGoogleDriveTokenLoaded);
    }, []);

    return googleDriveSearch;
};

export default useGoogleDriveSearch;
